import React, { useState } from 'react';
import { Box, Button, TextField, Autocomplete } from '@mui/material';
import { useDispatch } from 'react-redux';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { assignToCro } from '../../../redux/features/batchSlice';

const AssignCroModal = ({ open, setOpen, croList, selectedLeads, onSuccess }) => {
  const dispatch = useDispatch();
  const [selectedCro, setSelectedCro] = useState(null);
  const [remarks, setRemarks] = useState('');
  console.log('selectedLeads:', selectedLeads);
  console.log('selectedCro:', selectedCro);
  const handleAssignCro = () => {
    if (!selectedCro) return;

    const payload = {
      course_enrollment_ids: selectedLeads, // Array of IDs from checkedRowsIds
      assigned_to: selectedCro.userID, // Using userID from your API response
      remarks: remarks, // Added remarks field
    };

    console.log('Submit Payload:', payload);

    dispatch(assignToCro(payload)).then(() => {
      onSuccess?.();
      setOpen(false);
      setRemarks('');
      setSelectedCro(null);
    });
  };

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title="Assign CRO"
      maxWidth="sm"
      fullWidth
      closeButton
      content={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <Autocomplete
            options={croList || []}
            value={selectedCro}
            onChange={(e, value) => setSelectedCro(value)}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option?.userID === value?.userID}
            renderInput={(params) => <TextField {...params} label="Select CRO" required />}
          />

          <TextField
            label="Remarks"
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter assignment remarks..."
          />

          <Button variant="contained" onClick={handleAssignCro} disabled={!selectedCro}>
            Submit
          </Button>
        </Box>
      }
    />
  );
};

export default AssignCroModal;
